// Optimized font loading strategy
class FontLoader {
  constructor() {
    this.fontsLoaded = false;
    this.init();
  }

  init() {
    // Add loading class immediately
    document.documentElement.classList.add("fonts-loading");

    // Check if fonts are already loaded (from cache)
    if (this.areFontsLoaded()) {
      this.addFontsLoadedClass();
      return;
    }

    // Use requestIdleCallback for better performance
    if (window.requestIdleCallback) {
      requestIdleCallback(() => this.startFontLoading());
    } else {
      setTimeout(() => this.startFontLoading(), 1);
    }
  }

  startFontLoading() {
    if (document.fonts) {
      // Force font loading by creating temporary elements
      this.forceFontDownload();

      // Check for both critical fonts
      const criticalFonts = [
        "400 1em Montserrat",
        "700 1em Montserrat",
        "300 1em SackersGothicStd",
        "500 1em SackersGothicStd",
        "900 1em SackersGothicStd",
      ];

      Promise.all(criticalFonts.map((font) => document.fonts.load(font)))
        .then(() => {
          this.fontsLoaded = true;
          this.addFontsLoadedClass();
        })
        .catch(() => {
          // Fallback if font loading fails
          this.fallbackFontLoading();
        });
    } else {
      // Fallback for older browsers
      this.fallbackFontLoading();
    }
  }

  forceFontDownload() {
    // Create temporary elements to force font download
    const fontTestElements = [
      { font: "400 1em Montserrat", text: "A" },
      { font: "700 1em Montserrat", text: "A" },
      { font: "300 1em SackersGothicStd", text: "A" },
      { font: "500 1em SackersGothicStd", text: "A" },
      { font: "900 1em SackersGothicStd", text: "A" },
    ];

    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "-9999px";
    container.style.visibility = "hidden";
    container.style.pointerEvents = "none";

    fontTestElements.forEach(({ font, text }) => {
      const element = document.createElement("span");
      element.style.font = font;
      element.textContent = text;
      container.appendChild(element);
    });

    document.body.appendChild(container);

    // Remove after a short delay
    setTimeout(() => {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }, 1000);
  }

  areFontsLoaded() {
    if (!document.fonts) return false;
    return (
      document.fonts.check("400 1em Montserrat") &&
      document.fonts.check("700 1em Montserrat") &&
      document.fonts.check("300 1em SackersGothicStd") &&
      document.fonts.check("500 1em SackersGothicStd") &&
      document.fonts.check("900 1em SackersGothicStd")
    );
  }

  addFontsLoadedClass() {
    document.documentElement.classList.add("fonts-loaded");
    document.documentElement.classList.remove("fonts-loading");

    // Dispatch custom event for other components that might need to know
    window.dispatchEvent(new CustomEvent("fontsLoaded"));
  }

  fallbackFontLoading() {
    setTimeout(() => {
      this.fontsLoaded = true;
      this.addFontsLoadedClass();
    }, 1000);
  }
}

export default FontLoader;
